import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { globals } from '../globals';
import { AgrupamentoStringbox } from '../models/agrupamento-stringbox';
import { Marca } from '../models/marca';

@Injectable({
  providedIn: 'root'
})
export class AgrupamentoStringboxService {

  constructor(
    private http: HttpClient
  ) { }

  salvar(agrupamento: AgrupamentoStringbox) {
    return this.http.post(globals.apiUrl + '/api/AgrupamentoStringbox/Salvar', agrupamento);
  }

  alterarSituacao(idAgrupamento, ativo) {
    return this.http.patch(globals.apiUrl + '/api/AgrupamentoStringbox/AlterarSituacao', {},
      { params: new HttpParams().set('idAgrupamento', idAgrupamento).set('ativo', ativo) });
  }

  excluir(id) {
    return this.http.delete(globals.apiUrl + '/api/AgrupamentoStringbox/Excluir',
      { params: new HttpParams().set('id', id) });
  }

  consultarPorId(id) {
    return this.http.get<any>(globals.apiUrl + '/api/AgrupamentoStringbox/Buscar',
      { params: new HttpParams().set('id', id) });
  }

  consultarAgrupamentosStringbox() {
    return this.http.get<AgrupamentoStringbox[]>(globals.apiUrl + '/api/AgrupamentoStringbox/Lista');
  }

  consultarAgrupamentosStringboxPorInversor(idInversor) {
    return this.http.get<AgrupamentoStringbox[]>(globals.apiUrl + '/api/AgrupamentoStringbox/ListaPorInversor',
      { params: new HttpParams().set('idInversor', idInversor) }
    );
  }

  consultarComPaginacao(descri, paginaAtual, qtdRegistros, campoOrdenacao, asc_desc) {

    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', asc_desc)
      .set('descri', descri ? descri : '');

    return this.http.get<any>(globals.apiUrl + '/api/AgrupamentoStringbox/ListaPag',
      {
        params: parametros
      });
  }

  exportar() {
    const endPoint = '/api/AgrupamentoStringbox/Exportar';

    return this.http.get(`${globals.apiUrl}${endPoint}`, { responseType: 'blob' });
  }

  importar(dados) {
    return this.http.post(globals.apiUrl + '/api/AgrupamentoStringbox/Importar', dados);
  }

  buscarMarcas(filtroCombinacao) {
    return this.http.post<any>(globals.apiUrl + '/api/AgrupamentoStringbox/BuscarMarcas', filtroCombinacao);
  }

  buscarAgrupamentos(filtroCombinacao) {
    return this.http.post<any>(globals.apiUrl + '/api/AgrupamentoStringbox/BuscarAgrupamentos', filtroCombinacao);
  }
}
